<template>
  <div>
    <p
      v-if="dialogComponentName"
      class="mb-0 black2-color"
      :class="[labelClass ?? 'font-18 font-weight-medium main-label__wrapper']"
    >
      <span class="letter-spacing-4"> {{ text }} </span>
      <span
        class="align-self-start accent--text font-weight-semi-bold text-cursor"
        href="javascript:"
        @click="$emit('showModal', dialogComponentName)"
      >
        <v-icon color="#106175" class="tooltip text-decoration-none"
          >mdi-help-circle</v-icon
        ></span
      >
    </p>
    <p
      v-else
      class="mb-0 black2-color"
      :class="[labelClass ?? 'font-18 font-weight-medium']"
    >
      <span class="letter-spacing-4"> {{ text }} </span
      ><v-tooltip
        top
        color="primary"
        content-class="tooltipTop primary"
        v-if="helpText && helpText.length"
        ><template v-slot:activator="{ on, attrs }"
          ><v-icon
            color="accent"
            class="tooltip text-decoration-none"
            v-on="on"
            v-bind="attrs"
            >mdi-help-circle</v-icon
          ></template
        ><span v-html="helpText"></span
      ></v-tooltip>
      <slot name="actionLabel"></slot>
    </p>
    <p v-if="hintText" class="sub-help-text">
      {{ hintText }}
    </p>
  </div>
</template>

<script>
export default {
  name: "BaseLandlordLabel",
  props: {
    text: {
      type: String,
      required: true,
    },
    helpText: {
      type: String,
    },
    hintText: {
      type: String,
    },
    dialogComponentName: {
      type: String,
    },
    labelClass: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
i.tooltip.v-icon.v-icon {
  font-size: 18px !important;
  top: -2px !important;
  position: relative !important;
}

.sub-help-text {
  margin-top: 3px;
  margin-bottom: 13px;
  display: block;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: left;
  color: #272727;
  width: 584px;
}

.help-text {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: left;
  color: #272727;
}
.font-weight-400 {
  font-weight: 400 !important;
}

.letter-spacing-4 {
  letter-spacing: 0.4px;
}

@media screen and (max-width: $grid-breakpoints-md) {
  .sub-help-text {
    width: 100%;
  }
}
</style>
